import { render } from "./changeDirectionSVG.vue?vue&type=template&id=bec157b2"
import script from "./changeDirectionSVG.vue?vue&type=script&lang=js"
export * from "./changeDirectionSVG.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__